import React, { PureComponent } from 'react';

import './OrderSummaryNote.scss';

import { TERMS_AND_CONDITIONS_URL } from 'helpers';

interface OwnProps {
    email: string;
    hasDonation: boolean;
    isFinanceOrder: boolean;
}

class OrderSummaryNote extends PureComponent<OwnProps> {
    render() {
        const { hasDonation, isFinanceOrder } = this.props;

        return (
            <div className='order-summary-note'>
                <div className='order-summary-note__image'></div>
                <div className='order-summary-note__content'>
                    {
                        isFinanceOrder ? this.renderFinanceNotes() : this.renderNonFinanceNotes()
                    }
                    {
                        hasDonation
                        && <p className='order-summary-note__content__text'>
                            Thanks for donating with Pennies
                            <a className='order-summary-note__content__link' target='_blank' rel='noopener noreferrer' href={TERMS_AND_CONDITIONS_URL}>Terms and conditions</a>
                        </p>
                    }
                </div>
            </div>
        );
    }

    renderFinanceNotes(): JSX.Element {
        return (
            <>
                <h1 className='order-summary-note__content__title'>Thank You. Your application is complete.</h1>
                <p className='order-summary-note__content__text'>
                    Please look out for the email confirming your decision, and if accepted, inviting you to e-sign your agreement on your own device.
                </p>
                <p className='order-summary-note__content__text order-summary-note__content__finance-note'>
                    Please Note: We cannot begin working on your order until the e-signature process has been completed.
                </p>
            </>
        );
    }

    renderNonFinanceNotes(): JSX.Element {
        const { email } = this.props;

        return (
            <>
                <h1 className='order-summary-note__content__title'>Great news, its time to show off !</h1>
                <p className='order-summary-note__content__text'>
                    Your order was completed successfully and we've sent you a lovely email to <b>{email}</b>.</p>
                <p className='order-summary-note__content__text'>
                    You'll also find a link to the MySofology area, where you can manage it and do other cool stuff like book delivery when it's ready.
                </p>
            </>
        );
    }
}

export default OrderSummaryNote;